import { useRouter } from '@redneckz/wildless-cms-uni-blocks';
import { months } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/DatePicker/months';
import { Heading } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Heading/Heading';
import { type Option } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Select/Option';
import { Select } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Select/Select';
import { navigate } from 'gatsby';
import React, { useCallback, useState } from 'react';
import { MONTHS } from '../../createPagesHelpers/months';
import { YEARS } from '../../createPagesHelpers/years';
import { extractMonthFromPath, extractYearFromPath } from '../utils/extractDateFromPath';

const YEARS_OPTIONS = YEARS.map((key) => ({ key: String(key) }));

export const NewsFilterSelects = ({ categories }: { categories: Option[] }) => {
  const router = useRouter();

  const isPremiumUltra = router.pathname?.includes('/premium-ultra') || false;
  const [selectedCategory, setSelectedCategory] = useState<Option>(categories[0]);

  const preselectedYear = extractYearFromPath(router.pathname);
  const preselectedMonth = extractMonthFromPath(router.pathname)?.key;

  const handleSelectMonth = useCallback(
    (month: Option) => {
      navigate(
        `${isPremiumUltra ? '/premium-ultra/' : '/'}${
          preselectedYear || String(new Date().getFullYear())
        }-${month.key}`,
      );
    },
    [months],
  );

  const handleSelectYear = useCallback(({ key }: Option) => {
    navigate(
      `${isPremiumUltra ? '/premium-ultra/' : '/'}${key}-${
        extractMonthFromPath(router.pathname)?.key || MONTHS[new Date().getMonth()].key
      }`,
    );
  }, []);

  const handleSelectCategory = useCallback((option: Option) => {
    setSelectedCategory(option);
    navigate(`/${option?.key ? option.key : ''}`);
  }, []);

  return (
    <div className="space-y-m">
      <Heading className="hidden sm:block" headingType="h6" as="h4">
        По дате
      </Heading>
      <Select
        className="sm:hidden"
        label="Раздел"
        iconVersion="black"
        onChange={handleSelectCategory}
        value={selectedCategory}
        options={categories}
      />
      <div className="flex gap-m flex-col sm:flex-row">
        <Select
          iconVersion="black"
          onChange={handleSelectYear}
          value={{ key: preselectedYear || '' }}
          options={YEARS_OPTIONS}
          placeholder="Год"
        />
        <Select
          iconVersion="black"
          onChange={handleSelectMonth}
          value={MONTHS[Number(preselectedMonth) - 1]}
          options={MONTHS}
          placeholder="Месяц"
        />
      </div>
    </div>
  );
};
